// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__vm32Q","padre":"About_padre__2XncT"};